import { create } from 'zustand';

export interface AuthState {
  token: string | null;
  roles: string[] | [];
  permissions: string[] | [];
  activeModules: string[] | [];
  isLoggingIn: boolean;
  isLoggingOut: boolean;
  isAuthenticated: boolean;
  setToken: (newToken: string) => void;
  setRoles: (newRoles: string[]) => void;
  setPermissions: (newPermissions: string[]) => void;
  setActiveModules: (newModules: string[]) => void;
  reset: () => void;
  setIsLoggingIn: (isLoggingIn: boolean) => void;
  setIsLoggingOut: (isLoggingOut: boolean) => void;
  setIsAuthenticated: (isAuthenticated: boolean) => void;
}

const initialState = {
  token: null,
  roles: [],
  permissions: [],
  activeModules: [],
  isLoggingIn: false,
  isLoggingOut: false,
  isAuthenticated: false,
};

export const useAuthStore = create<AuthState>()((set) => ({
  ...initialState,
  setToken: (newToken) => set(() => ({ token: newToken })),
  setIsLoggingIn: (isLoggingIn) => set(() => ({ isLoggingIn })),
  setIsLoggingOut: (isLoggingOut) => set(() => ({ isLoggingOut })),
  setIsAuthenticated: (isAuthenticated) => set(() => ({ isAuthenticated })),
  setRoles: (newRoles) => set((/* state */) => ({ roles: newRoles })),
  setPermissions: (newPermissions) => set((/* state */) => ({ permissions: newPermissions })),
  setActiveModules: (newModules) => set((/* state */) => ({ activeModules: newModules })),
  reset: () => set(initialState),
}));
